<template>
  <div>
    <div class="title">如何注册和登录美菜账户？</div>
    <div class="content-info">
      <p class="txt1">
        <b>APP :</b> 下载美菜APP，在“我的”界面点击“未登录账户”进入“登录/注册”界面。按提示完成操作即可；
      </p>
      <ul>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/2db4e634253ed4f123ae3fe6e90a79b3.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/f8cf334dcee518d90f2984146c420149.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/22ce9c8675d5a46b8140e3c07cc29c91.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/4f7c318a2c991c0db658c960d93be67b.png" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
